module.exports = __webpack_public_path__ + "img/logo-vector-large.5f8dd2dc.svg";